// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBK84nRKdRoss7X-jQKLDSO_HNOBj9hdW4",
  authDomain: "ecommerceproductgenerate05.firebaseapp.com",
  projectId: "ecommerceproductgenerate05",
  storageBucket: "ecommerceproductgenerate05.firebasestorage.app",
  messagingSenderId: "242791792907",
  appId: "1:242791792907:web:76f07db500b3fdc705e20e",
};
// Initialize Firebase
const app = initializeApp(firebaseConfig);

const auth = getAuth(app);

export default auth;
 